const usercsvcolumndata = [
  {
    id: "user_uuid",
    title: "ID",
  },
  {
    id: "name",
    title: "Name",
    default: true,
  },
  {
    id: "username",
    title: "Username",
    default: true,
  },
  {
    id: "user_email",
    title: "Email",
    default: true,
  },
  {
    id: "user_enabled",
    title: "Status",
  },
];
export default usercsvcolumndata;
